import styled, { css } from 'styled-components';
import MediaSizes from '@widgets/shared/MediaSizes';
export const FormElement = styled.form `

`;
export const Wrapper = styled.div `
  color: white;
  position: relative;
  overflow: hidden;
  
  
`;
export const MemberWrapper = styled.div `
  background-color: white;
  
  #fitness-page & {
    background-color: var(--primary-medium);
  }

  ${Wrapper} + & {
    padding: 5rem 0;

    @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
      padding: 3rem 0;
    }
  }
`;
export const MemberList = styled.div `
  
`;
export const ActionList = styled.ul `
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 0;
  padding: 0;
  
  & + ${MemberList} {
    margin-top: 4rem;
  }
  
  & ~ & {
    margin-top: 5rem;
  }
  
  &:has(.tag) {
    .btn {
      padding: 2rem 4rem;
    }
  }

  @supports not (:has() {
    .btn {
      padding: 2rem 4rem;
    }
  })
  
  .btn.btn--primary {
    background-color: var(--stepped-quiz-btn);
    border-color: var(--stepped-quiz-btn);
    
    &:hover {
      background-color: var(--stepped-quiz-btn-hover);
      border-color: var(--stepped-quiz-btn-hover);
    }
    
    #fitness-page & {
      background-color: var(--primary-btn);
      border-color: var(--primary-btn);
      
      &:hover {
        background-color: var(--primary-btn-hover);
        border-color: var(--primary-btn-hover);
      }
    }
  }
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    & + ${MemberList} {
      margin-top: 2rem;
    }
    
    & ~ & {
      margin-top: 3rem;
    }
    
    li {
      flex: 0 calc(50% - 0.5rem);
      
      
      button {
        width: 100%;
      }
    }
    
    .btn.btn--wide {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }
`;
export const DurationItem = styled.li `
  position: relative;
  input {
    display: none;
  }
  
  .btn.btn--primary {
    &:hover {
      background-color: var(--navy-dark);
      border-color: var(--navy-dark);
    }
  }
`;
export const QuestionWrapper = styled.div `
  ${({ hidden }) => {
    if (hidden) {
        return css `
        display: hidden;
      `;
    }
}})}
`;
export const NotFound = styled.span `
  font: var(--heading-two-font);
  text-align: center;
  margin-top: 4rem;
  display: block;
`;
export default {
    Wrapper,
};
